export default __webpack_public_path__ + "static/project-slide-6-4032-2268-3c760a53b595d270cc4d9f757eba3663.jpg";